module.exports = __webpack_public_path__ + "img/qrcode-ico.5d53bda9.png";